import useSWR from 'swr';
import { fetcher } from '../base';

export function useProducts({ product = 'tees', size, sort }) {
  const params = new URLSearchParams();
  if (size) params.set('size', size);
  if (sort) params.set('sort', sort);

  return useSWR(`shop/${product}?${params.toString()}`, fetcher);
}
